"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CardConfig = /*#__PURE__*/function () {
  function CardConfig(store, helpers, shopperEmail, amount) {
    var _this = this;
    _classCallCheck(this, CardConfig);
    _defineProperty(this, "onChange", function (state) {
      _this.store.updateSelectedPayment('scheme', 'isValid', state.isValid);
      _this.store.updateSelectedPayment('scheme', 'stateData', state.data);
    });
    _defineProperty(this, "onSubmit", function () {
      var submitPaymentButton = document.querySelector(_this.submitPaymentButtonSelector);
      submitPaymentButton.disabled = false;
      submitPaymentButton.click();
    });
    _defineProperty(this, "onFieldValid", function (data) {
      if (data.endDigits) {
        _this.store.endDigits = data.endDigits;
        document.querySelector(_this.cardNumberSelector).value = _this.store.maskedCardNumber;
      }
    });
    _defineProperty(this, "onBrand", function (brandObject) {
      document.querySelector(_this.cardTypeSelector).value = brandObject.brand;
    });
    this.hasHolderName = true;
    this.holderNameRequired = false;
    this.enableStoreDetails = window.showStoreDetails;
    this.clickToPayConfiguration = {
      shopperEmail: shopperEmail,
      merchantDisplayName: window.merchantAccount
    };
    this.exposeExpiryDate = false;
    this.store = store;
    this.helpers = helpers;
    this.amount = amount;
    this.submitPaymentButtonSelector = 'button[value="submit-payment"]';
    this.cardNumberSelector = '#cardNumber';
    this.cardTypeSelector = '#cardType';
  }
  return _createClass(CardConfig, [{
    key: "setInstallments",
    value: function setInstallments(config) {
      var _window$Configuration,
        _window$installments,
        _this2 = this;
      var installmentLocales = ['pt_BR', 'ja_JP', 'tr_TR', 'es_MX'];
      if (installmentLocales.indexOf((_window$Configuration = window.Configuration) === null || _window$Configuration === void 0 ? void 0 : _window$Configuration.locale) < 0) {
        return;
      }
      var installments = JSON.parse((_window$installments = window.installments) === null || _window$installments === void 0 ? void 0 : _window$installments.replace(/&quot;/g, '"'));
      if (installments !== null && installments !== void 0 && installments.length && this.amount) {
        var installmentOptions = {};
        installments.forEach(function (installment) {
          var _installment = _slicedToArray(installment, 3),
            minAmount = _installment[0],
            numOfInstallments = _installment[1],
            cards = _installment[2];
          if (minAmount <= _this2.amount.value) {
            cards.forEach(function (cardType) {
              if (!installmentOptions[cardType]) {
                installmentOptions[cardType] = {
                  values: [1]
                };
              }
              if (!installmentOptions[cardType].values.includes(numOfInstallments)) {
                installmentOptions[cardType].values.push(numOfInstallments);
                installmentOptions[cardType].values.sort(function (a, b) {
                  return a - b;
                });
              }
            });
          }
        });
        config.installmentOptions = installmentOptions;
        config.showInstallmentAmounts = true;
      }
    }
  }, {
    key: "setFastlaneConfiguration",
    value: function setFastlaneConfiguration(config) {
      var _this$store$fastlane = this.store.fastlane,
        authResult = _this$store$fastlane.authResult,
        configuration = _this$store$fastlane.configuration;
      if ((authResult === null || authResult === void 0 ? void 0 : authResult.authenticationState) !== 'succeeded' && configuration) {
        config.fastlaneConfiguration = configuration.fastlaneConfiguration;
      }
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      var defaultConfig = {
        hasHolderName: this.hasHolderName,
        holderNameRequired: this.holderNameRequired,
        enableStoreDetails: this.enableStoreDetails,
        clickToPayConfiguration: this.clickToPayConfiguration,
        exposeExpiryDate: this.exposeExpiryDate,
        onChange: this.onChange,
        onSubmit: this.onSubmit,
        onFieldValid: this.onFieldValid,
        onBrand: this.onBrand
      };
      this.setInstallments(defaultConfig);
      this.setFastlaneConfiguration(defaultConfig);
      return defaultConfig;
    }
  }]);
}();
module.exports = CardConfig;